import en from './en'
const ROOT: typeof en = {
  langName: '繁體中文',
  login: {
    title: '登入 SmartController',
    account: '帳號',
    password: '密碼',
    failed: '登入失敗。'
  },
  term: {
    title: '首頁',
    about: '關於',
    login: '登入',
    logout: '登出',
    unknown: '未知',
    defaultValue: '預設值',
    preview: '預覽',
    actions: '動作',
    // device
    tx: 'TX',
    rx: 'RX',
    online: '上線',
    offline: '離線',
    uptime: '上線時間',
    loading: '載入中...',
    // dialog
    save: '儲存',
    apply: '套用',
    cancel: '取消',
    close: '關閉',
    reset: '重設',
    clear: '清除',
    discard: '拋棄',
    // continue: '繼續',
    ok: '好',
    yes: '是',
    no: '否',
    delete: '刪除',
    available: '可用',
    unavailable: '不可用',
    valid: '有效',
    invalid: '無效',
    enabled: '已啟用',
    disabled: '已禁用',
    active: '活動中',
    inactive: '不啟用',
    running: '運作中',
    stopped: '已停止',
    detected: '有',
    undetected: '未偵測到',
    unused: '未配對',
    filter: '過濾器',
    invalidSetting: '無效的設定',
    edit: '編輯',
    editSetting: '修改設定',
    status: '狀態',
    name: '名稱',
    name_help: '僅供使用者辨識',
    note: '備忘錄',
    rename: '重新命名',
    untitled: '未命名',
    selectAll: '全選',
    centering: '置中',
    create: '新增',
    upload: '上傳',
    really: '確定嗎？',
    back: '上一步',
    next: '下一步',
    finish: '完成',
    deleted: '已刪除',
    error: '錯誤',
    warning: '警告',
    applying: '套用中...',
  },
  call: {
    vwNamed: '電視牆「{0}」',
    osdNamed: 'OSD「{0}」',
    imgNamed: '圖片「{0}」',
    presetNamed: '預設組態「{0}」',
    rx: {
      matrixFrom: '從「{0}」',
      inVw: '在「{0}」內'
    },
    tx: {
      matrixTo: '到 {0} RX | 到 {0} RX',
      inVw: '到 {0} RX | 到 {0} RX',
    }
  },
  msg: {
    applyDone: '套用成功！',
    applyFailed: '發生錯誤，請稍後再試。',
    deleteConfirm: '確定要刪除{0}嗎？',
    nameCannotDuplicated: '此名字已經存在，請取其他名字。',
    nameIsRequired: '請輸入名字。',
    commingSoon: '即將推出',
    clickAddToCreate: '目前没有任何項目，請按右下角的「+」以新增項目。'
  },
  edidMode: {
    title: 'EDID 模式',
    fixed: '固定',
    fixed_help: '手動指定一個固定的 EDID',
    fixed_desc: '（{0}）',
    learning: '學習',
    learning_help: '自動從另一台 RX 學習過來',
    learning_desc: '（從「{0}」）'
  },
  enum: {
    rotateFlip: {
      title: '旋轉與翻轉'
    }
  },
  modal: {
    dev: {
      details: {
        title: '詳細資訊',
        id: '識別',
        network: '網路',
        status: '狀態',
        io: '輸入輸出',
        av: '聲音與影像',
        osd: 'OSD',
        advanced: '進階功能',
        version: '版本',
      },
      rename: {
        title: '重新命名此台 Extender'
      },
      edid: {
        title: 'EDID 設定',
        description: '對接上的影音輸入源來說，這台 TX 扮演的角色就像是電視。透過 EDID 設定，可以讓這台 TX 偽裝成支援特定解析度的電視。',
        presetList: '預設值列表',
        learnFrom: '從...學習'
      },
    },
    networkError: {
      desc: '糟糕，網路連線似乎發生了問題，正在嘗試重新連接...',
      retryButton: '立刻重試'
    },
    closeConfirm: {
      title: '儲存修改？',
      desc: '未儲存的修改將會遺失。',
    },
  },
  maintenance: {
    title: '維護',
    reboot: {
      title: '重開機',
      desc: '重新啟動這台 Extender',
      prompt: '重新啟動這台 Extender？',
    },
    resetToFactory: {
      title: '回復出廠設定',
      desc: '將此台 Extender 的設定回復為原廠設定',
      prompt: '這個操作將會刪除此台 Extender 中現有的所有設定，確定要繼續？'
    },
    blinkLed: {
      title: '閃爍信號燈',
      desc: '閃爍信號燈，指示出此台 Extender 的確切位置',
      hasBeingBlinking: '信號燈已經在閃爍了！',
      blinkedSuccessfully: '正在閃爍信號燈，請檢查機器！'
    }
  },
  dev: {
    // System
    deviceName: '名稱',
    deviceType: '類型',
    modelName: '型號',
    serialNumber: '序號',
    uptime: '系統開機時間',
    connectionTime: '連線時間',
    groupID: '群組ID',
    // Network
    mac: 'MAC 地址',
    ip: 'IP 地址',
    netmask: '子網路遮罩',
    gateway: '網路閘道',
    multicastAddress: '多播地址',
    lanStatus: 'LAN連線狀態',
    baudRate: '鮑率',
    kBitRate: '比特率',
    // AV
    audioMuteFlag: '靜音',
    disableAVOutput: '關閉影音源',
    loopOut: '複製輸入源',
    loopOut_help: '讓輸入中的影音同時輸出到 TX 的 Loop-out HDMI 埠',
    clientSource: '訊號來源',
    // Standard
    cecFlag: 'CEC',
    cecFlag_help: 'CEC 可以讓支援的裝置（電視、影音源）透過 HDMI 線互動',
    edidMode: 'EDID 模式',
    hdcpStatus: 'HDCP',
    hdcpStatus_tx: '訊號源是否需要 HDCP',
    hdcpStatus_rx: '連接中的電視是否支援 HDCP',
    // Status
    txInputSourceDetected: '是否偵測到有信號輸入',
    rxTvConnectionDetected: '是否偵測到有電視連接',
    hdmiPlugged: '有 HDMI 訊號',
    // Display
    upScaleMode: '影像縮放模式',
    osdResolution: '',
    rxCurrentResoultion: '',
    // Version
    series: 'Extender 系列',
    series_short: '系列',
    version: '版本',
    rxVersion: 'RX 版本',
    txVersion: 'TX 版本',
    controlVersion: 'Controller 版本',
    encoderVersion: '編碼器版本',
  },
  matrix: {
    title: '映射',
    remap_tx: '配送到 RX...',
    remap_rx: '從 TX 收訊...',
    cannotMapOfflineRx: '無法配對已離線的 RX',
    profileList: {
      save: {
        label: '儲存目前狀態',
        title: '儲存目前狀態',
        desc: '將目前映射的狀態儲存'
      },
      load: {
        label: '載入',
        title: '載入',
        desc: '載入先前儲存的狀態'
      },
      msg: {
        savedSuccess: '目前狀態成功保存為「{0}」。',
        loadedSuccess: '成功載入「{0}」'
      },
    },
  },
  vw: {
    title: '電視牆',
    apply: '套用此電視牆',
    list: {
      title: '所有電視牆'
    },
    name: '名稱',
    id: 'ID',
    active: '開關',
    osd: '編號 OSD',
    osd_help: '在 RX 螢幕上顯示流水編號',
    layout: '尺寸',
    dragArea_help: '請將 {0} 拖至此處',
    dragTxPlease_help: '請從 TX 列表中將 TX 拖曳至電視牆上。',
    dragRxPlease_help: '這個位置還沒有 RX，請從 RX 列表中將 RX 拖曳至電視牆上。',
    warnBeforeClearMappings: '修改此設定將會清空這個電視牆現有的 TX 與 RX 安排。',
    removeSelected: '把選取的 {0} 從此電視牆移除',
    txMapper: {
      title: '為此電視牆安排 TX',
      title_short: '安排 TX',
    },
    rxMapper: {
      title: '為此電視牆安排 RX',
      title_short: '安排 RX',
    },
    create: {
      title: '新增一個新的電視牆'
    },
    resize: {
      title: '調整電視牆尺寸'
    },
    vendor: {  // series
      title: '修改此電視牆的 Extender 系列'
    },
    bezel: {
      title: '邊框校正',
    },
    rotateFlip: {
      title: '旋轉與翻轉',
    },
    delete: {
      title: '刪除此面電視牆',
      desc: '將會刪除此面電視牆的一切設定（但 TX、RX 自身原有的設定並不受影響）',
    },
    details: {
      title: '電視牆設定',
      mapping: 'RX/TX 對應',
      basic: '基本',
    },
    rename: {
      title: '重新命名電視牆'
    },
    showDisplayIndex: {
      title: '在每個 RX 上面顯示流水編號',
      help: '在每個 RX 上面顯示流水編號，用來確認 RX 是否有被正確擺放。',
      warn: '警告：這個功能將會清除目前這個電視牆中的所有 RX 現有的 OSD 設定',
      show: '顯示編號',
      hide: '移除編號',
    },
  },
  deviceList: {
    title: '裝置列表',
    viewMode: '檢視方式',
    info: '詳細資訊',
    rename: '重新命名',
    showingField: '顯示欄位',
  },
  osd: {
    title: 'OSD',
    label: 'OSD',
    image: '圖片',
    text: '文字',
    alignment: '對齊',
    content: '文字內容',
    shiftX: '水平偏移',
    shiftY: '垂直偏移',
    color: '顏色',
    fontSize: '字體大小',
    opacity: '不透明度',
    select: '選擇一個 OSD',
    create: '建立新 OSD',
    edit: '編輯 OSD',
    cannotDeleteBecauseOccupiedByOther: '目前無法刪除，因為這個 OSD 正被其他設定使用中：',
  },
  osdimg: {
    title: '圖片',
    select: '選擇一張圖片',
    create: '上傳新圖片',
    edit: '編輯這張圖片',
    mask: '遮罩',
  },
  sys: {
    title: '系統',
    lang: {
      title: '語言',
      auto: '自動',
      auto_help: '盡可能和瀏覽器的設定相同'
    },
    ui: {
      title: '操作界面'
    },
    basicinfo: {
      title: '資訊',
      status: '狀態',
      basicInfo: '基本資訊',
      hwInfo: '系統資訊',
      versions: '版本',

      cpu: 'CPU 使用率',
      ram: 'メモリ使用率',
      disk: 'デバイス使用率',

      upTime: '上線時間',
      date: '系統時間',
      name: '名稱',
      description: '敘述',
      location: '位置',
      contact: '聯絡方式',
      macAddr: 'MAC 位置',
      serialNumber: '序號 (SN)',
      hardwareModel: '硬體型號',
      hardwareDescription: '硬體敘述',
      swKernelVersion: '軟體核心版本',
      softwareVersion: '軟體版本',
      libVersion: '函式庫版本',
      version: '版本',
      vendor: '製造商',
      platform: '平台',
    },
    network: {
      title: '網路',
      mode: '模式',
      static: '固定（手動）',
      dhcpClient: 'DHCP 客戶端（自動）',
      dns: 'DNS',
      requiredIfCloud: '如須使用雲端，此欄位為必須',
    },
    maintenance: {
      title: '維護',
      reboot: '重開機',
      reboot_help: '重開這台 Controller',
    }
  },
  thumbSize: {
    title: '縮圖尺寸',
    xs: '超小',
    sm: '小',
    md: '中',
    lg: '大',
    xl: '超大'
  },
  preset: {
    title: '狀態儲存/載入',  // 預先布置、預置、布置
    create: {
      title: '儲存目前狀態',
      help: '請選擇你想要儲存的「電視牆」與「映射」狀態。（注：只有目前正被用作「映射」的Extender才會出現在映射列表中。）',
      conflict: '選取的「電視牆」或「映射」中有重複的 RX，這會造成衝突。',
    },
    rename: {
      title: '重新命名這個狀態',
    },
    apply: {
      title: '套用此組態',
    },
    summary: {
      matrix: '無映射 | {0} 組映射',
      vw: '無電視牆 | {0} 組電視牆',
    },
  },
  schedule: {
    title: '排程'
  },
  validate: {
    osdTextCharSet: '只能使用英文字母與數字、底限、破折號等字元。'
  },
  model: {
    hg: 'HG 系列 (1G)',
    hx: 'HX 系列 (10G)',
  },
}
export default ROOT
